// Per-page Edit Mode — the desktop convention, ported: each data surface
// (Dashboards, Entity Info, Vocabulary, Ontology Editor) owns its own
// edit flag and renders this shared toggle in its page button row.
// Orange when ON, gray when OFF, default OFF. QQL deliberately has no
// UPDATE: mutation only flows through the substrate's semantic endpoints,
// so this per-surface mode is the gate where fine-grained permissions
// will attach later. Callers gate `visible` on the user's role (power
// user + admin); regular users never see it and surfaces stay read-only.

import { cn } from '@/lib/utils';

export function EditModeButton({
  on,
  onToggle,
  visible,
}: {
  on: boolean;
  onToggle: (on: boolean) => void;
  visible: boolean;
}) {
  if (!visible) return null;
  return (
    <button
      type="button"
      onClick={() => onToggle(!on)}
      aria-pressed={on}
      title={
        on
          ? 'Edit mode is ON — this page shows editing actions. Click to switch to read-only.'
          : 'Edit mode is OFF — this page is read-only. Click to enable editing actions.'
      }
      className={cn(
        'rounded-md border px-2.5 py-1 text-xs font-medium transition-colors',
        on
          ? 'border-tres-edit bg-tres-edit text-white hover:bg-tres-edit/90'
          : 'border-border bg-card text-tres-text-secondary hover:bg-muted',
      )}
    >
      {on ? 'Edit Mode: ON' : 'Edit Mode'}
    </button>
  );
}
